
/**
 * Code for infinite Scroll
 */

function hideElement(element) {
  element.style.display = "none";
}

function setupInfiniteScroll(section) {
  const nextButtonSelector = '.pagination .paginate-next-button';
  const pagination = section.querySelector(".pagination .paginate-prev-button");
  const loading = section.querySelector(".list--inline.pagination");

  // When infinite scroll is active, pagination
  // buttons should stay hidden
  if (pagination instanceof HTMLElement) {
    hideElement(pagination);
  }
  if (loading instanceof HTMLElement) {
    // loading.innerHTML = "&nbsp;";
    loading.style.opacity = "0";
  } else {
    // Loading element is integral to the infinite scroll
    // because it will be used as intersection target
    return;
  }

  

  const observer = new IntersectionObserver(function(entries, observer) {
    const entry = entries[0];
    if (entry.isIntersecting) {
      // Unsubscribe right away
      // observer.unobserve(entry.target);
      
      // do something
      renderNextSection();
    }
  });

  observer.observe(loading);

  async function renderNextSection() {

    let nextButton = section.querySelector(nextButtonSelector);
    // Grap url of next page from the button href
    let nextPageUrl;
    if (nextButton instanceof HTMLAnchorElement) {
      nextPageUrl = nextButton.href;
    }
    // If there is no next page link, there is no work to be done.
    if (!nextPageUrl) {
      hideElement(loading);
      return;
    }

    // Fetch collection section from next page
    const collectionTemplate = 'collection-template';
    let nextPageSectionHtml;


    
    
    // Method using normal AJAX call
    try {
      const response1 = await fetch(nextPageUrl).then(function (res1) {
      	return res1.text();
      }).then(function (html) {
      	
        d = document.createElement('div');
        d.innerHTML = html
        nextPageCollectionHTML = d.querySelector('#Collection ul');
        newNextButtonEl = d.querySelector(nextButtonSelector);
        nextButton.replaceWith(newNextButtonEl);

        // Insert section HTML after the current section
        // section.insertAdjacentHTML("afterend", nextPageCollectionHTML.innerHTML);
        const ulList = section.querySelector('ul.grid--view-items');
        ulList.insertAdjacentHTML("beforeend", nextPageCollectionHTML.innerHTML);
        const nextPageSection = section.nextElementSibling;
    
        if (nextPageSection instanceof HTMLElement) {
          // Setup infinite scroll on the next section
          setupInfiniteScroll(nextPageSection);
        }

        
      }).catch(function (err) {
      	console.warn('Something went wrong.', err);
      });
      
    } catch (err) {
      console.error(err);
    }
    
    

    /**
    // Method using Shopify Section API
    try {
      const response = await fetch(nextPageUrl + "&sections="+collectionTemplate);
      const data = await response.json();
      nextPageSectionHtml = data[collectionTemplate];
    } catch (err) {
      console.error(err);
    }
    
    //If server returns nothing, leave.
    if (!nextPageSectionHtml) return;

    // if (loading instanceof HTMLElement) {
      // hideElement(loading);
    // }

    d = document.createElement('div');
    d.innerHTML = nextPageSectionHtml
    nextPageCollectionHTML = d.querySelector('#Collection ul');
    newNextButtonEl = d.querySelector(nextButtonSelector);
    nextButton.replaceWith(newNextButtonEl);

    // Insert section HTML after the current section
    // section.insertAdjacentHTML("afterend", nextPageCollectionHTML.innerHTML);
    const ulList = section.querySelector('ul.grid--view-items');
    ulList.insertAdjacentHTML("beforeend", nextPageCollectionHTML.innerHTML);
    const nextPageSection = section.nextElementSibling;

    if (nextPageSection instanceof HTMLElement) {
      // Setup infinite scroll on the next section
      setupInfiniteScroll(nextPageSection);
    }
    */
    

    
  }


  if(window.localStorage.getItem("[WBLS-52] // 0.01") == "v1"){
    let auto_loop_count = 0;
    let max_auto_loop = 5;
    
    const auto_loop = setInterval(() => {
      renderNextSection();
      auto_loop_count++;
      console.log("auto_loop", auto_loop_count);
      
      if(document.querySelectorAll('.pagination .paginate-next-button').length == 0 || 
      auto_loop_count >= max_auto_loop) {
       clearInterval(auto_loop);
      }
    }, 2500);
  }
  
  
}


function initMainCollection(section) {
  // setupButtonsEvents(section);
  if (window.IntersectionObserver) {
    setupInfiniteScroll(section);
  }
}

async function initInfiniteScroll() {
  const { templateName } = document.body.dataset;
  // if (templateName === "collection") {
    const sectionElement = document.getElementById( "Collection" );
    if (sectionElement instanceof HTMLElement) {
      initMainCollection(sectionElement);
    }
  // }
}

// fix reviews display for more compact mobile experience
observeSelector('.grid-view-item .jdgm-prev-badge__text', grid_item_review => {
  let review_count = grid_item_review.innerText.replace(" reviews", "").replace(" review", "");
  grid_item_review.innerText = `(${review_count})`;
});

document.addEventListener("DOMContentLoaded", initInfiniteScroll);